<template>
  <div v-if="post">
    <v-article :post="post" return-label="Return to News" :return-to="{name: 'weekly-updates', params: {homeSlug}}">

    </v-article>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import VArticle from '@/components/Article.vue';

  export default {
    metaInfo() {
      return {
        title: this.post.title + ' | News'
      }
    },
    props: {
      homeSlug: String,
      slug: String
    },
    components: {
      VArticle
    },
    mounted() {
      this.fetchNewsItem({home: this.homeSlug, slug: this.slug})
    },
    methods: {
      ...mapActions(['fetchNewsItem'])
    },
    computed: {
      post() {
        return this.$store.getters.getNewsItem(this.slug);
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
